import {
    convertUniversalDateTimeToPersianDateTime, convertUniversalDateToPersianDate,
    RaikoBaseCardContainer, RaikoCustomTable,
    RaikoGridOneColumn,
    RaikoTableTitleContainer, showErrorMessage
} from "@moeindal/base-raiko-panel-components";
import {useAuthState} from "../../../context/AuthContext";
import {useEffect, useState} from "react";
import {OtherPaymentService} from "../../../serverService/otherPayment/OtherPaymentService";
import {useParams} from "react-router-dom";
import {detectServerErrorMessage} from "../../../util/detectServerErrorMessage";
import RaikoShowPrice from "../../../raikoComponents/raikoShowPrice/RaikoShowPrice";

export default function AccountTransactions() {

    const {fundID} = useAuthState()
    const {id: accountId} = useParams()

    const size = 15
    let page = 0

    const service = new OtherPaymentService()


    useEffect(() => {
        getDataFromServer();
    }, []);

    const [transactions, setTransactions] = useState([]);

    const [pageCount, setPageCount] = useState(0);
    const [totalItems, setTotalItems] = useState(0);
    const [tableLoading, setTableLoading] = useState(false);

    function handlePagination(newPage) {
        page = newPage
        getDataFromServer()
    }

    function prepareTransactionTableRow(id, number, amount, applicator, date, doAt, doBy, kind) {
        return {
            number,
            code: id,
            id,
            kind,
            amount: <RaikoShowPrice amount={amount}/>,
            date: convertUniversalDateToPersianDate(date),
            doAt: convertUniversalDateTimeToPersianDateTime(doAt),
            applicator,
            doBy,
        }
    }

    function getDataFromServer() {
        setTableLoading(true)
        service.getTransactions(
            fundID,
            accountId,
            page,
            size
        ).then(response => {
            setTotalItems(response.numberOfItems)
            setPageCount(response.totalPage)
            setTransactions([])
            response.data.map((item, index) => {
                setTransactions(prev => [
                    ...prev,
                    prepareTransactionTableRow(
                        item.id,
                        (page * size) + index + 1,
                        item.amount,
                        item.applicator,
                        item.date,
                        item.doAt,
                        item.doBy,
                        item.kind
                    )
                ])
            })

        }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            setTableLoading(false)
        })
    }


    return (
        <RaikoGridOneColumn>
            <RaikoBaseCardContainer>
                <RaikoGridOneColumn>
                    <RaikoTableTitleContainer
                        title={"گردش حساب"}
                        amount={totalItems}
                    />
                    <RaikoCustomTable
                        header={header}
                        data={transactions}
                        isLoading={tableLoading}
                        handlePaginationChange={handlePagination}
                        pageCount={pageCount}
                        emptyListTitle={"هیچ تراکنشی برای این حساب یافت نشد!"}
                        emptyListSubtitle={""}
                    />
                </RaikoGridOneColumn>
            </RaikoBaseCardContainer>
        </RaikoGridOneColumn>
    )
}


const header = [
    {
        id: "number",
        label: "#"
    }, {
        id: "code",
        label: "شناسه"
    }, {
        id: "kind",
        label: "عنوان"
    }, {
        id: "amount",
        label: "مبلغ (ریال)"
    }, {
        id: "date",
        label: "تاریخ"
    }, {
        id: "applicator",
        label: "نوع انجام دهنده"
    }, {
        id: "doBy",
        label: "اعمال کننده"
    }, {
        id: "doAt",
        label: "تاریخ ثبت"
    },
]
